import { useT } from "@transifex/react";
import type { ReactNode } from "react";

interface EvaluationsSectionProps {
    children?: ReactNode;
}

export const EvaluationsSection = (props: EvaluationsSectionProps) => {
    const t = useT();
    const t_evaluations = t("Evaluations", { _tags: "ClassMemberDashboard, EvaluationsSection" });

    return (
        <section className="flex flex-col gap-s w-full">
            <h2 className="text-xl text-p6-grey-dark font-normal">{t_evaluations}</h2>
            {props.children}
        </section>
    );
};
